"use strict";

module.exports = /*@ngInject*/function ($resource, ConfigService) {
  var _ConfigService$getCon = ConfigService.getConfig(),
    INSPECT_URL = _ConfigService$getCon.INSPECT_URL;
  return $resource("".concat(INSPECT_URL, "/api/party-to-people"), {});
};